/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomerApiService } from './customer-api.service';
import { ConfigService } from 'src/app/service/config.service';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root',
})
export class AlertApiService {
  private alertingUrl: string;

  constructor(
    private api: CustomerApiService,
    private http: HttpClient,
    private config: ConfigService,
    private tokenService: TokenService,
  ) {
    this.alertingUrl = this.config.appConfig.urlAlertingServiceApi;
  }

  // SCORE/EVENT ALERTS

  getAlerts(type: string): Observable<any> {
    return this.api.get('/v1/alerts', { alert_type: type });
  }

  addAlert(data: any): Observable<any> {
    return this.api.post('/v1/alerts', data);
  }

  removeAlert(uid: string): Observable<any> {
    return this.api.delete('/v1/alerts/' + uid);
  }

  setIndicator(alert: boolean, iparams: any): Observable<any> {
    const endpoint = alert
      ? '/v1/investment_ratio_alerts/activate'
      : '/v1/investment_ratio_alerts/deactivate';
    return this.api.get(endpoint, {
      sector: iparams.id,
      strategy: iparams.overlay,
    });
  }

  // ALERTING SERVICE (separate base URL)

  triggerAlert(uid: string): Observable<any> {
    const decoded = this.tokenService.decodeToken();
    return this.http.get(`${this.alertingUrl}/v2/alert/trigger`, {
      params: {
        uid,
        created_by: decoded?.email || '',
      },
    });
  }

  getAlertHistory(uid: string): Observable<any> {
    return this.http.get(`${this.alertingUrl}/channel/history`, {
      params: { uid },
    });
  }
}
